export enum TradebookProviderType {
  Any = -1,
  BlackBook = 0,
  Galves = 1,
  BlueBook = 2,
  Manheim = 3,
  Carfax = 4,
  None = 5,
}
